
const state = {
    saleItems: [],
    selectedSaleItemIndex: null,
    selectedSaleItem: {},
    totalSaleAmount: null,
    newSaleItem: {
        id: null,
        name: null,
        result: null,
        commission: null,
        auction_fee: null,
        inland_transport: null,
        discount: null,
        total: null,

    }
}

const getters = {
    getCustomInvoiceSaleItems: (state) => {
        return state.saleItems
    },
    getCustomInvoiceSelectedSaleItem: (state) => {
        return state.selectedSaleItem
    },
    getCustomInvoiceTotalSaleAmount: (state) => {
        return state.totalSaleAmount
    },
    getCustomInvoiceNewSaleItem: (state) => {
        return state.newSaleItem
    }
}

const mutations = {
    setCustomInvoiceSaleItems: (state, newItems) => {
        state.saleItems = newItems
    },
    setCustomInvoiceSelectedSaleItem: (state, newItem) => {
        state.selectedSaleItem = newItem
    },
    setCustomInvoiceSelectedSaleItemIndex: (state, newItem) => {
        state.selectedSaleItemIndex = newItem
    },
    setCustomInvoiceSelectedSaleItemFieldValue: (state, data) => {
        state.selectedSaleItem[data.field] = data.value
    },
    setCustomInvoiceNewSaleItemFieldValue: (state, data) => {
        state.newSaleItem[data.field] = data.value
    },
    pushNewCustomInvoiceNewSaleItem: (state) => {
        state.saleItems.push(state.newSaleItem)
        state.newSaleItem = {
            id: null,
            name: null,
            result: null,
            commission: null,
            auction_fee: null,
            inland_transport: null,
            discount: null,
            total: null,
        }
    },
    setCustomInvoiceTotalSaleAmount: (state) => {
        let newValue = 0
        state.saleItems.forEach(function(element) {
            newValue = Number(newValue) + Number(element.total)
        })
        state.totalSaleAmount = newValue

    },
    replaceCustomInvoiceSaleItemWithSelectedSaleItem: (state) => {
        state.saleItems[state.selectedSaleItemIndex] = state.selectedSaleItem
        state.selectedSaleItem = {}
    },
    removeCustomInvoiceSaleItem: (state, item) => {
        state.saleItems = state.saleItems.filter(i => i !== item)
    }
}

const actions = {
    changeCustomInvoiceTotalSaleAmount: ({ commit }) => {
        commit('setCustomInvoiceTotalSaleAmount')
    },
    changeCustomInvoiceSaleItems: ({ commit }, newItems) => {
        commit('setCustomInvoiceSaleItems', newItems)
    },
    changeCustomInvoiceSelectedSaleItem: ({ commit }, newItem) => {
        commit('setCustomInvoiceSelectedSaleItem', newItem)
    },
    changeCustomInvoiceSelectedSaleItemIndex: ({ commit }, newItem) => {
        commit('setCustomInvoiceSelectedSaleItemIndex', newItem)
    },
    changeCustomInvoiceSelectedSaleItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setCustomInvoiceSelectedSaleItemFieldValue', newFieldValue)
    },
    changeCustomInvoiceNewSaleItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setCustomInvoiceNewSaleItemFieldValue', newFieldValue)
    },
    updateCustomInvoiceSaleItem: ({ commit }) => {
        commit('replaceCustomInvoiceSaleItemWithSelectedSaleItem')
    },
    saveCustomInvoiceSaleItem: ({ commit }) => {
        commit('pushNewCustomInvoiceNewSaleItem' )
    },
    deleteCustomInvoiceSaleItem: ({ commit }, item) => {
        commit('removeCustomInvoiceSaleItem', item)
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/customInvoiceSalesItems.js